module.exports = __webpack_public_path__ + "img/Support-skill-332.338766b3.png";